import { render, staticRenderFns } from "./RmpAuthLayout.vue?vue&type=template&id=02547945"
import script from "./RmpAuthLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpAuthLayout.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports